"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _index = require("./index");
var _constants = require("../../../utils/constants");
var _underscore = _interopRequireDefault(require("underscore"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SimpleMultiDropdown = function SimpleMultiDropdown(props) {
  var items = props.items,
    selectedItems = props.selectedItems,
    onSelectedItemsChange = props.onSelectedItemsChange,
    error = props.error,
    creatable = props.creatable,
    disabled = props.disabled,
    required = props.required,
    helperText = props.helperText,
    placeholder = props.placeholder;

  // TODO: Find a better solution for picking the labelProps off of props without having to cast them - https://greenhouseio.atlassian.net/browse/GREEN-40416
  // We need to provide the labelProps as a spread object for the types to work properly
  var labelProps = _underscore["default"].pick(props, 'label', 'ariaLabel', 'ariaLabelledBy');
  var wrappedSelectedItemsChanged = function wrappedSelectedItemsChanged(_ref) {
    var selectedItems = _ref.selectedItems;
    onSelectedItemsChange && selectedItems && onSelectedItemsChange(selectedItems);
  };
  var dropdownProps = (0, _index.useMultiDropdown)({
    items: items,
    selectedItems: selectedItems,
    creatable: creatable,
    onSelectedItemsChange: wrappedSelectedItemsChanged
  });
  return /*#__PURE__*/React.createElement(_index.MultiDropdown, null, /*#__PURE__*/React.createElement(_index.MultiDropdown.Field, (0, _extends2["default"])({
    dropdownProps: dropdownProps,
    error: error,
    helperText: helperText,
    placeholder: placeholder,
    disabled: disabled,
    required: required
  }, labelProps, (0, _constants.getDataProvidesProps)(props, function (dataProvidesString) {
    return "".concat(dataProvidesString, "-field");
  }))), /*#__PURE__*/React.createElement(_index.MultiDropdown.Flyout, (0, _extends2["default"])({
    dropdownProps: dropdownProps
  }, (0, _constants.getDataProvidesProps)(props, function (dataProvidesString) {
    return "".concat(dataProvidesString, "-field");
  }))));
};
var _default = exports["default"] = SimpleMultiDropdown;